import { IParcelsConstraint } from "components/generics/Interface/Simulation/IParcelsConstraint";

export const updateObligationItem = (
    value: number[] | string | string[],
    index: number,
    attr: string,
    obligationAndRestriction: IParcelsConstraint[],
    yearsOptions: [{ id: number, value: string }]) => {
    let constraints = [...obligationAndRestriction];
    let checkIsOk = true;
    switch (attr) {
        case 'parcel':
            constraints[index].Parcel_Id = value as number[];
            checkIsOk = checkObligationExist(constraints[index], obligationAndRestriction);
            if (!checkIsOk) {
                constraints[index].Parcel_Id.splice(constraints[index].Parcel_Id.length - 1, 1);
            }
            break;
        case 'culture':
            constraints[index].Exploitation_Culture_Id = value as number[];
            checkIsOk = checkObligationExist(constraints[index], obligationAndRestriction);
            if (!checkIsOk) {
                constraints[index].Exploitation_Culture_Id?.splice(
                    constraints[index].Exploitation_Culture_Id.length - 1,
                    1
                );
            }

            break;
        case 'year':
            constraints[index][attr] = value as string;
            break;
        case 'years':
            if (value[value.length - 1] === 'all-years') {
                if (constraints[index]?.[attr]?.length === yearsOptions.length) {
                    constraints[index][attr] = [];
                } else {
                    constraints[index][attr] = yearsOptions.map((year: { id: number, value: string }) => year.id.toString());
                }
            } else {
                constraints[index][attr] = value as string[];
            }

            checkIsOk = checkObligationExist(constraints[index], obligationAndRestriction);
            if (!checkIsOk) {
                if (constraints[index]?.[attr]?.length) {
                    constraints[index][attr]?.splice((constraints[index]?.years?.length ?? 0) - 1, 1);
                }
            }

            break;
        case 'constraint':
            constraints[index].constraint = value as string;
            break;
        default:
            break;
    }
    return { checkIsOk, constraints }

};

export const getYearsOptions = (currentYear: number, nbYears: number, startingYear = 0) => {
    if (startingYear > 0) {
        currentYear += startingYear
    }
    let nextYearCampaign = currentYear + 1;
    let yearsOptions = [];
    for (let i = 0; i < nbYears - startingYear; i++) {
        yearsOptions.push({
            id: nextYearCampaign + i,
            value: `${currentYear + i} - ${nextYearCampaign + i}`,
        });
    }
    return yearsOptions;
};

export const checkObligationExist = (value: IParcelsConstraint, obligationAndRestriction: IParcelsConstraint[]) => {
    let found = obligationAndRestriction.filter(
        (obligationAndRestrictionItem: IParcelsConstraint) =>
            obligationAndRestrictionItem.Parcel_Id.filter((parcelItem: number) => value.Parcel_Id.indexOf(parcelItem) >= 0).length > 0 &&
            (obligationAndRestrictionItem?.Exploitation_Culture_Id ?? []).filter((exploitationCultureItem: number) => (value?.Exploitation_Culture_Id ?? []).indexOf(exploitationCultureItem) >= 0).length > 0 &&
            obligationAndRestrictionItem?.years && obligationAndRestrictionItem.years.filter((yearsItem: string) => (value?.years ?? []).indexOf(yearsItem) >= 0).length &&
            // Division is not antinomic with obligation/interdiction
            obligationAndRestrictionItem.constraint !== 'division'
    );
    return found.length > 1 ? false : true;
};

export const deleteValueObligationItem = (index: number, indexAttr: number, attr: string, obligationAndRestriction: IParcelsConstraint[]) => {
    let obligations = [...obligationAndRestriction];
    switch (attr) {
        case 'years':
            obligations[index][attr]?.splice(indexAttr, 1);
            break;
        case 'cultures':
            obligations[index]?.Exploitation_Culture_Id?.splice(indexAttr, 1);
            break;
        case 'parcels':
            obligations[index].Parcel_Id.splice(indexAttr, 1);
            break;
        default:
            break;
    }
    return obligations;
};

export const deleteObligationItem = (index: number, obligationAndRestriction: IParcelsConstraint[]) => {
    let obligations = [...obligationAndRestriction];
    obligations.splice(index, 1);
    return obligations;
}